module.exports = __webpack_public_path__ + "img/products_big_can_original.f05e880b.png";